import { Bar, Line } from "react-chartjs-2";
import React, { useEffect, useState } from "react";

import ChartAnnotations from "chartjs-plugin-annotation";
import PropTypes from "prop-types";
import { find } from "lodash";
import moment from "moment";

const LineChartOnshoreWest = props => {
  function numberFormat(number, digit = 2) {
    if (number === null || number === "null" || number === "") return "";
    function isFloat(n) {
      return Number(n) === n && n % 1 !== 0;
    }
    if (typeof number == "string") {
      if (number.includes("+")) {
        return (
          "+ " +
          parseFloat(number.replaceAll("+", "").trim())
            .toFixed(digit)
            .toLocaleString(undefined, {
              minimumFractionDigits: digit,
            })
        );
      }
      if (number.includes("-")) {
        return (
          "- " +
          parseFloat(number.replaceAll("-", "").trim())
            .toFixed(digit)
            .toLocaleString(undefined, {
              minimumFractionDigits: digit,
            })
        );
      }
    }
    if (isFloat(number))
      return parseFloat(number.toFixed(digit)).toLocaleString(undefined, {
        minimumFractionDigits: digit,
      });
    return parseFloat(number).toLocaleString(undefined, {
      minimumFractionDigits: digit,
    });
  }
  const [min, setMin] = useState(null)
  const [max, setMax] = useState(null)
  const [data, setData] = useState({
    labels: [],
    datasets: [
      {
        label: "East",
        backgroundColor: "#94C7FC",
        borderColor: "#94C7FC",
        borderWidth: 2,
        hoverBackgroundColor: "#94C7FC",
        hoverBorderColor: "#94C7FC",
        data: [],
        type: "line",
        showLine: true,
        fill: false,
        tension: 0,
        spanGaps: false,
        pointStyle: "dot",
        borderDashOffset: 0.5,
        borderDash: [8, 8],
        pointRotation: 50,
        pointBorderWidth: 3,
        hoverBorderWidth: 10,
        pointRadius: 2,
      },
      {
        label: "West",
        backgroundColor: "#A9DAB3",
        borderColor: "#A9DAB3",
        borderWidth: 2,
        hoverBackgroundColor: "#A9DAB3",
        hoverBorderColor: "#A9DAB3",
        showLine: true,
        fill: false,
        tension: 0,
        spanGaps: false,
        pointStyle: "dot",
        borderDashOffset: 0.5,
        borderDash: [8, 8],
        pointRotation: 50,
        pointBorderWidth: 3,
        hoverBorderWidth: 10,
        pointRadius: 2,
      },
      {
        label: "Total",
        backgroundColor: "#EA8EC5",
        borderColor: "#EA8EC5",
        borderWidth: 5,
        pointBorderWidth: 5,
        hoverBorderWidth: 10,
        hoverBackgroundColor: "#EA8EC5",
        hoverBorderColor: "#EA8EC5",
        data: [],
        type: "line",
        showLine: true,
        pointStyle: "dot",
        pointRadius: 3,
        fill: false,
        tension: 0,
      },
    ],
  });
  const target = 5;
  const [option, setOption] = useState({
    maintainAspectRatio: false,
    layout: {
      padding: {
        right: 20
      }
    },
    scales: {
      dataset: [
        {
          barPercentage: 0.4,
        },
      ],
      xAxes: [
        {
          scaleLabel: {
            display: true,
            fontSize: 14,
            labelString: "Date",
            fontColor: "#FFFFFF",
            fontStyle: "bold",
          },
          gridLines: {
            display: true,
          },
          ticks: {
            fontColor: "#FFFFFF",
            fontStyle: "bold",
            fontSize: 14,
          },
        },
      ],
      yAxes: [
        {
          display: true,
          scaleLabel: {
            display: true,
            fontSize: 14,
            labelString: "Percent (%)",
            fontColor: "#FFFFFF",
            fontStyle: "bold",
          },
          gridLines: {
            display: true,
          },
          ticks: {
            fontColor: "#FFFFFF",
            fontStyle: "bold",
            fontSize: 14,
            callback: function (label, index, labels) {
              var val = Math.abs(label);
              // if (val >= 1000) {
              //   if (label < 0) {
              //     val = val * -1;
              //   }
              // val = numberFormat(val/1000, 1) + " K";
              // } else {
              if (label < 0) {
                val = val * -1;
              }
              val = numberFormat(val, 0);
              // }

              return val;
            },
          },
        },
      ],
    },
    legend: {
      labels: {
        fontColor: "#FFFFFF",
        fontStyle: "bold",
        fontSize: 14,
        generateLabels: chart => chart.data.datasets.map((dataset, i) => ({
          datasetIndex: i,
          text: dataset.label,
          fillStyle: dataset.backgroundColor,
          strokeStyle: dataset.borderColor
        })),
        filter: item => {
          if (item.text != "MAX" && item.text != "MIN") {
            return true;
          }
        },
      },

    },
    tooltips: {
      enabled: true,
      mode: 'nearest',
      intersect: false,
      titleFontSize: 20,
      bodyFontSize: 18,
      bodyFontStyle: "bold",
      callbacks: {
        label: function (tooltipItem, data) {
          // console.log(tooltipItem);
          // console.log(data);
          // var indice = tooltipItem.index;
          return "  " + numberFormat(tooltipItem.yLabel, 1) + " %";
        }
      },
    },
    annotation: {
      annotations: [
        {
          type: "line",
          mode: "horizontal",
          scaleID: "y-axis-0",
          value: target,
          borderColor: "#FF4545",
          borderWidth: 2,
          borderDash: [10, 5],
          // borderDashOffset: 5,
          label: {
            backgroundColor: "rgba(0,0,0,0)",
            fontSize: 12,
            fontStyle: "bold",
            fontColor: "#FF4545",
            position: "right",
            enabled: true,
            content: "Max",
            yAdjust: 10,
          },
        },
        {
          type: "line",
          mode: "horizontal",
          scaleID: "y-axis-0",
          value: -target,
          borderColor: "#FF4545",
          borderWidth: 2,
          borderDash: [10, 5],
          label: {
            backgroundColor: "rgba(0,0,0,0)",
            fontSize: 12,
            fontStyle: "bold",
            fontColor: "#FF4545",
            position: "right",
            enabled: true,
            content: "Min",
            yAdjust: 10,
          },
        }
      ],
    },
  })
  useEffect(() => {

    let minMaxObj = props.minMax.find(row => {
      if (row.endDate != null) {
        return (
          row.startDate <= moment(props.date).toDate() &&
          moment(props.date).toDate() <= row.endDate
        );
      } else {
        return row.startDate <= moment(props.date).toDate();
      }
    });
    if (minMaxObj) {
      setOption(prev => ({
        ...prev,
        annotation: {
          ...prev.annotation,
          annotations: [{ ...prev.annotation.annotations[0], value: minMaxObj.max }, { ...prev.annotation.annotations[1], value: minMaxObj.min }]
        }
      }))
    }
    let dataSort = props.balancingGraphData
      .sort(function (a, b) {
        return moment(a.REPORT_DATE).toDate() - moment(b.REPORT_DATE).toDate();
      })
    // .slice(Math.max(props.balancingGraphData.length - 15, 1));
    let dateList = [moment(props.date).locale("en").format("D MMM")];

    for (let index = 0; index < 14; index++) {

      dateList.unshift(
        moment(props.date)
          .add("days", -(index + 1))
          .locale("en")
          .format("D MMM")
      );

    }
    let dataGraph = { east: [], west: [], total: [] }
    dateList.map(item => {
      let dataEast = dataSort.filter(row => row.BALANCING_ZONE.toLowerCase() == "east").find(row => {
        if (item == moment(props.date).locale("en").format("D MMM")) {

          return (
            moment(row.REPORT_DATE).locale("en").format("D MMM") == item &&
            props.summaryReportPid == row.SUMMARYREPORT_PID
          );
        }

        return (
          moment(row.REPORT_DATE).locale("en").format("D MMM") == item
        );
      });
      dataGraph.east.push(dataEast?.BALANCING_BALANCE);
      let dataWest = dataSort.filter(row => row.BALANCING_ZONE.toLowerCase() == "west").find(row => {
        if (item == moment(props.date).locale("en").format("D MMM")) {

          return (
            moment(row.REPORT_DATE).locale("en").format("D MMM") == item &&
            props.summaryReportPid == row.SUMMARYREPORT_PID
          );
        }

        return (
          moment(row.REPORT_DATE).locale("en").format("D MMM") == item
        );
      });
      dataGraph.west.push(dataWest?.BALANCING_BALANCE);
      let dataTotal = dataSort.filter(row => row.BALANCING_ZONE.toLowerCase() == "total").find(row => {
        if (item == moment(props.date).locale("en").format("D MMM")) {

          return (
            moment(row.REPORT_DATE).locale("en").format("D MMM") == item &&
            props.summaryReportPid == row.SUMMARYREPORT_PID
          );
        }

        return (
          moment(row.REPORT_DATE).locale("en").format("D MMM") == item
        );
      });
      dataGraph.total.push(dataTotal?.BALANCING_BALANCE);
    });
    // console.log(dataGraph)
    setData(prev => ({
      ...prev,
      labels: dateList,
      datasets: [{ ...prev.datasets[0], data: dataGraph.east }, { ...prev.datasets[1], data: dataGraph.west }, { ...prev.datasets[2], data: dataGraph.total }],
    }));

    // console.log(props.balancingGraphData)
  }, [props.balancingGraphData]);
  return (
    <React.Fragment>
      <Line data={data} options={option} />
      {/* width={190} height={70}  */}
    </React.Fragment>
  );
};
LineChartOnshoreWest.propTypes = {
  t: PropTypes.any,

  balancingGraphData: PropTypes.any,
  minMax: PropTypes.any,
  date: PropTypes.any,
  summaryReportPid: PropTypes.any,
};

export default LineChartOnshoreWest;
